export default "__VITE_ASSET__DWGng8$u__"